import { Typography } from "components/typography";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import changelogMarkdown from "../../../changelog.md?raw";
import { PageContainer } from "../base";

export const ChangelogPage = () => {
  const preMd = `
This changelog records the updates made to MindlerCare. 

Our goal is to provide greater transparency to users about the changes on the site.
`;

  return (
    <PageContainer>
      <Typography insensitive variant="h1">
        {"Changelog"}
      </Typography>
      <Markdown remarkPlugins={[remarkGfm]}>{preMd}</Markdown>
      <Markdown remarkPlugins={[remarkGfm]}>{changelogMarkdown}</Markdown>
    </PageContainer>
  );
};
